import { useState } from 'react'

const useConfirmAssignmentModal = ({ methods, data }) => {
  const [error, setError] = useState(false)

  const handleUpdate = () => {
    if (data.remarks.trim() === '') {
      setError(true)
      return
    }
    setError(false)
    methods.handleUpdate()
  }

  return {
    data: {
      error
    },
    methods: {
      handleUpdate
    }
  }
}

export default useConfirmAssignmentModal